;(function() {
  'use strict'

  Controller.$inject = ["colors"];
  angular.module('app.core').component('quotaPlanHeader', {
    controller: Controller,
    templateUrl: 'quota-plan-header.html',
    bindings: {
      plan: '<',
      plans: '<',
      channels: '<',
      onChange: '&',
      onRename: '&',
      onDelete: '&',
    },
  })

  /* @ngInject */
  function Controller(colors) {
    var ctrl = this

    var signature = null

    ctrl.$doCheck = doCheck

    ctrl.setEnabled = setEnabled
    ctrl.setChannelIds = setChannelIds
    ctrl.hasTagOnlySeparateQuota = hasTagOnlySeparateQuota

    function doCheck() {
      var next = buildSignature()
      if (next === signature) return

      signature = next
      refresh()
    }

    function buildSignature() {
      return [
        _.map(ctrl.channels, 'id').join(','),
        ctrl.plan ? ctrl.plan.channelIds.join(',') : '',
        ctrl.plan ? String(ctrl.plan.enabled) : '',
        _.map(ctrl.plans, function(plan) {
          return plan.id + ':' + plan.channelIds.join('+')
        }).join(','),
      ].join('|')
    }

    function refresh() {
      refreshOptions()
      refreshCoverage()

      ctrl.selectedChannelIds = ctrl.plan ? ctrl.plan.channelIds.slice() : []
    }

    function refreshOptions() {
      var otherPlans = _.filter(ctrl.plans, function(plan) {
        return !ctrl.plan || plan.id !== ctrl.plan.id
      })

      ctrl.channelOptions = _.map(ctrl.channels, function(channel) {
        var owner = _.find(otherPlans, function(plan) {
          return _.includes(plan.channelIds, channel.id)
        })

        return {
          label: channel.name,
          value: channel.id,
          disabled: !!owner,
          tag: owner ? 'in ' + owner.name : null,
          tagColor: colors.Colors.GREY_SILVER,
        }
      })
    }

    function refreshCoverage() {
      var claimed = _.flatMap(ctrl.plans, 'channelIds')

      ctrl.uncoveredChannels = _.filter(ctrl.channels, function(channel) {
        return !_.includes(claimed, channel.id)
      })

      ctrl.uncoveredChannelNames = _.map(ctrl.uncoveredChannels, 'name').join(
        ', '
      )
    }

    function hasTagOnlySeparateQuota() {
      if (!ctrl.plan) return false

      return _.some(ctrl.plan.getQuotas(), function(quota) {
        if (!quota.isIndependent()) return false

        var variables = quota.variables || []
        if (!variables.length) return false

        return _.every(variables, function(variable) {
          return variable.isTag()
        })
      })
    }

    function setEnabled(enabled) {
      ctrl.plan.setEnabled(enabled)
      ctrl.onChange()
    }

    function setChannelIds(channelIds) {
      ctrl.plan.setChannelIds(channelIds)
      ctrl.onChange()
    }
  }
})()
